import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import router from "./router";

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import MarqueeText from 'vue-marquee-text-component'

Vue.component('marquee-text', MarqueeText)

import moment from 'moment'; //dateModifier
Vue.filter('myDate', function(value){
  return moment(value).format('MMMM Do YYYY');
});

Vue.filter('truncate', function (text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})

Vue.filter('Time', function(value){
  return moment(value).format('h:mm a');
});

Vue.filter('comma', function(value){
  return value.toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

var d = new Date();
Vue.prototype.$currentDate = moment(d).format('YYYY-MM-DD', "Asia/Kolkata");


Vue.prototype.$pdfurl = "https://admin.bharatsamachartvnews.com/epapers/";
// Vue.prototype.$pdfurl = "http://127.0.0.1:8000/epapers/";
Vue.prototype.$urlpath = "https://admin.bharatsamachartvnews.com/epapers/thumb/";

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app');
